import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendOrderFulfillmentUpdateEmailMutationVariables = Types.Exact<{
  order_fulfillment_id: Types.Scalars['ID'];
}>;


export type SendOrderFulfillmentUpdateEmailMutation = { __typename?: 'Mutation', sendOrderFulfillmentUpdateEmail: boolean };


export const SendOrderFulfillmentUpdateEmailDocument = gql`
    mutation SendOrderFulfillmentUpdateEmail($order_fulfillment_id: ID!) {
  sendOrderFulfillmentUpdateEmail(order_fulfillment_id: $order_fulfillment_id)
}
    `;
export type SendOrderFulfillmentUpdateEmailMutationFn = Apollo.MutationFunction<SendOrderFulfillmentUpdateEmailMutation, SendOrderFulfillmentUpdateEmailMutationVariables>;

/**
 * __useSendOrderFulfillmentUpdateEmailMutation__
 *
 * To run a mutation, you first call `useSendOrderFulfillmentUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrderFulfillmentUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrderFulfillmentUpdateEmailMutation, { data, loading, error }] = useSendOrderFulfillmentUpdateEmailMutation({
 *   variables: {
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *   },
 * });
 */
export function useSendOrderFulfillmentUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOrderFulfillmentUpdateEmailMutation, SendOrderFulfillmentUpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrderFulfillmentUpdateEmailMutation, SendOrderFulfillmentUpdateEmailMutationVariables>(SendOrderFulfillmentUpdateEmailDocument, options);
      }
export type SendOrderFulfillmentUpdateEmailMutationHookResult = ReturnType<typeof useSendOrderFulfillmentUpdateEmailMutation>;
export type SendOrderFulfillmentUpdateEmailMutationResult = Apollo.MutationResult<SendOrderFulfillmentUpdateEmailMutation>;
export type SendOrderFulfillmentUpdateEmailMutationOptions = Apollo.BaseMutationOptions<SendOrderFulfillmentUpdateEmailMutation, SendOrderFulfillmentUpdateEmailMutationVariables>;